import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Added "segment" to the targets list
  static targets = [ "recordingInput", "dayInput", "hourInput", "segment", "timeMarker" ];
  static values = { indexUrl: String }

  connect() {
    this.updateRecordingArray();
    // Initial calculation of heights
    this.renderProportionalHeights();
  }

  // Automatically runs whenever a new segment-item enters the DOM
  segmentTargetConnected() {
    this.renderProportionalHeights();
  }

  renderProportionalHeights() {
    // 0.5 means 60 seconds = 30px height.
    // Increase this number if the segments look too "squashed".
    const pixelsPerSecond = 0.5;

    this.segmentTargets.forEach(segment => {
      const durationSpan = segment.querySelector(".duration");
      if (!durationSpan) return;

      // Extracts the number from "(60 sec)"
      const totalSeconds = parseInt(durationSpan.dataset.seconds);

      if (!isNaN(totalSeconds)) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        // Pads seconds with a leading zero if under 10
        const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        segment.style.height = `${seconds * pixelsPerSecond}px`;

        durationSpan.textContent = `${formattedTime}`;

        // Essential styles for scannability
        segment.style.height = `${totalSeconds * pixelsPerSecond}px`;
        segment.style.minHeight = "40px"; // Prevents very short segments from hiding text
        segment.style.display = "flex";
        segment.style.flexDirection = "column";
        segment.style.justifyContent = "center";
        segment.style.overflow = "hidden";
        segment.style.borderBottom = "1px solid #dee2e6";
      }
    });

    // Align the Timeline Ruler Markers
    // We look for markers with text like ":15", ":30", etc.
    const markers = this.element.querySelectorAll(".time-marker");
    markers.forEach(marker => {
      const timeMatch = marker.textContent.match(/\d+/);
      if (timeMatch) {
        const minutes = parseInt(timeMatch[0]);
        // Position = minutes * 60 seconds * pixelsPerSecond
        const topPosition = minutes * 60 * pixelsPerSecond;
        marker.style.top = `${topPosition}px`;
      }
    });
  }

  updateRecordingArray() {
    const ids = this.recordingInputTargets.map(input => input.value.trim());
    if (this.hasHiddenArrayInputTarget) {
      this.hiddenArrayInputTarget.value = JSON.stringify(ids);
    }
    console.log("Current Recording IDs:", ids);
  }

  selectRecording(event) {
    const segmentElement = event.currentTarget.closest(".segment-item");
    const chosenId = "REC-12345";
    segmentElement.dataset.recordingId = chosenId;
    segmentElement.querySelector(".selected-recording-display").innerText = chosenId;
    this.updateRecordingArray();
  }

  async submitSchedule(event) {
    event.preventDefault()
    this.syncGlobalValues();

    const form = event.currentTarget;
    const submitButton = form.querySelector('input[type="submit"], button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    const url = event.currentTarget.action
    const formData = new FormData(event.currentTarget)

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: { "Accept": "application/json" }
      })
      const data = await response.json();
      if (response.ok) {
        window.location.href = this.indexUrlValue;
      } else {
        this.handleError(data.error);
      }
    } catch (error) {
      this.handleError("Network error or server is down.");
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  }

  syncGlobalValues() {
    const hourSelector = document.getElementById("hour");
    if (hourSelector) {
      this.hourInputTarget.value = hourSelector.value;
    }
    const calendarWrapper = document.querySelector('[data-program-schedule-calendar-current-date-value]');
    if (calendarWrapper) {
      this.dayInputTarget.value = calendarWrapper.dataset.programScheduleCalendarCurrentDateValue;
    }
  }

  handleError(message) {
    console.error("Scheduling Error:", message);
    const container = document.getElementById("flash-container");
    if (container) {
      container.innerHTML = "";
      const alertDiv = document.createElement("div");
      alertDiv.className = "alert alert-danger flash_notice";
      alertDiv.innerText = message;
      container.appendChild(alertDiv);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      alert(message);
    }
  }
}
